<template>
  <div v-if="visible" class="welcome-page">
    <div class="welcome-content">
      <div class="welcome-title">欢迎您来到</div>
      <div class="welcome-subtitle">数智健康管理中心</div>
      <div class="welcome-tips">请点击屏幕开始</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 当 Welcome 显示时，添加事件监听
        this.$nextTick(() => {
          document.addEventListener('click', this.handleClick);
          document.addEventListener('touchstart', this.handleClick);
        });
      } else {
        // 当 Welcome 隐藏时，移除事件监听
        document.removeEventListener('click', this.handleClick);
        document.removeEventListener('touchstart', this.handleClick);
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('touchstart', this.handleClick);
  },
  methods: {
    handleClick() {
      // 通过 emit 通知父组件隐藏 Welcome
      this.$emit('hide');
    }
  }
}
</script>

<style scoped lang="scss">
.welcome-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0066cc 0%, #004499 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
  .welcome-content {
    text-align: center;
    color: #fff;
    
    .welcome-title {
      font-family: 'YouSheBiaoTiHei', 'PingFang SC', sans-serif;
      font-size: 60px;
      font-weight: 400;
      margin-bottom: 30px;
      opacity: 0.9;
    }
    
    .welcome-subtitle {
      font-family: 'YouSheBiaoTiHei', 'PingFang SC', sans-serif;
      font-size: 72px;
      font-weight: 600;
      margin-bottom: 80px;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    
    .welcome-tips {
      font-size: 32px;
      opacity: 0.7;
      animation: pulse 2s infinite;
    }
  }
}

@keyframes pulse {
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.7;
  }
}
</style>